<template lang="pug">
  // 名刺エクスポート権限を持つユーザーの場合、表示する
  span(v-if="$store.getState('login_user').bcard_exportable === app_flag.ON")
    button.btn.btn-default(type="button" @click="openExport" title="エクスポート" data-testid="btn-func-export"): i.fa.fa-download

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 未選択
      app-modal(v-model="modalNoItem" type="info")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      //- エクスポート確認
      form(v-if="modalConf", ref="form", @submit.prevent="")
        app-modal(v-model="modalConf" type="primary" size="large")
          template(slot="title") 確認
          //- 全件エクスポート
          h4(v-if="useSearch")
            strong.text-danger 全ページの名刺情報
            | をCSVファイルへエクスポートしますか？
          // ID指定エクスポート
          h4(v-else) 選択した名刺情報をCSVファイルへエクスポートしますか？
          p エクスポートには時間がかかることがあります。
          .form-horizontal
            export-settings(ref="exportSettings")
          template(slot="footer", slot-scope="{close}")
            button.btn.btn-primary(type="submit" @click="exports") エクスポート
            button.btn.btn-default(type="button" @click="close") キャンセル

      //- エクスポート中
      app-modal(v-model="modalExecuting" type="info" :showClose="false")
        template(slot="title") エクスポート実行中
        h4
          i.icon.fa.fa-spinner.fa-pulse
          | &nbsp;ただいまCSVファイルへエクスポート中です。
        p エクスポートには時間がかかることがあります。しばらくお待ちください。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(@click="cancel(); close()") キャンセル

      //- 成功
      app-modal(v-model="modalSuccess" type="success")
        template(slot="title") エクスポート完了
        h4 CSVファイルのエクスポートが完了しました。
        p [ダウンロード]ボタンをクリックしてファイルをダウンロードしてください。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button" @click="download()")
            i.fa.fa-download
            |  ダウンロード
          button.btn.btn-default(type="button" @click="close()") 閉じる

      //- 失敗
      app-modal(v-model="modalError" type="warning")
        template(slot="title") エクスポートエラー
        h4 CSVファイルのエクスポートに失敗しました。
        p エラーメッセージ: {{message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる

      //- キャンセル
      app-modal(v-model="modalCancel")
        template(slot="title") エクスポート中止
        h4 CSVファイルのエクスポートを中止しました。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import mixinForm from '@/mixins/form'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import ExportSettings from '@/components/organisms/ExportSettings'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')

export default {
  name: 'FuncExport',
  components: { AppModal, AppMessages, ExportSettings },
  mixins: [ mixinForm ],
  props: {
    /**
     * checkedIds（ID指定の場合に使う）
     */
    checkedIds: { type: Array, required: false, default () { return [] } },
    /**
     * useSearch（全件選択の場合に使う）
     */
    useSearch: { type: Boolean, required: false, default: false },
    /**
     * conds（全件選択の場合に使う）
     *    - search_target（必須）
     */
    conds: { type: Object, required: false, default () { return {} } }
  },
  data () {
    return {
      message: '',
      modalNoItem: false,
      modalConf: false,
      modalExecuting: false,
      modalSuccess: false,
      modalError: false,
      modalCancel: false,
      isDownloading: false // ダウンロード中
    }
  },
  created () {
    // poratl内のformにrefがある場合の処理
    this.setFormInPortalWhenCreated()
  },
  methods: {
    openExport () {
      // 全件検索なのにsearch_targetがない場合
      if ((this.useSearch && !this.conds.search_target) ||
          // ID指定なのにIDが未選択の場合
          (!this.useSearch && !this._getCondsOfIds())) {
        // 未選択エラー
        this.modalNoItem = true
        return
      }

      this.modalConf = true
    },
    /**
     * エクスポート実行
     */
    exports () {
      // ExportSettingsのsaveCookie()を呼び出す
      this.$refs.exportSettings.saveCookie()

      // 本番用
      const vm = this
      const formData = new FormData(this.$refs.form)

      // 全件検索なのにsearch_targetがない場合
      if ((this.useSearch && !this._setCondsOfSearchTarget(formData)) ||
          // ID指定なのにIDが未選択の場合
          (!this.useSearch && !this._setCondsOfIds(formData))) {
        vm.showToast('検索条件が正しく設定されていないため、エクスポートできません。', { type: 'danger' }) // system error
        return false
      }

      formData.append('is_mgmt', this.isMgmt ? this.app_flag.ON : this.app_flag.OFF)

      this.modalConf = false
      this.modalExecuting = true

      // API実行
      BcardRepository.postExport(formData)
        .then(this.onExportSuccess)
        .catch(function (error) {
          vm.onExportError(vm, error)
        })

      // // mock用
      // setTimeout(() => {
      //   if ((+new Date()) % 2 === 0) {
      //     this.onExportSuccess()
      //   }
      //   else {
      //     const error = { response: { data: { data: { message: 'エラーメッセージさんぷるうるるる' } } } }
      //     this.onExportError(this, error)
      //   }
      // }, 1000)
    },
    /**
     * 名刺IDの検索条件を取得
     * @return {string}
     */
    _getCondsOfIds () {
      return this.checkedIds.length ? this.checkedIds.join(',') : ''
    },
    /**
     * 名刺IDの検索条件をセット
     * @return {boolean} セットしたかどうか
     */
    _setCondsOfIds (formData) {
      const ids = this._getCondsOfIds()
      if (!ids) {
        return false
      }

      formData.append('sid_bcards', ids)

      if (this.conds['sort_item']) {
        formData.append('sort_item', this.conds['sort_item'])
      }
      if (this.conds['direction']) {
        formData.append('direction', this.conds['direction'])
      }

      return true
    },
    /**
     * 任意の検索条件をセット
     * @return {boolean} セットしたかどうか
     */
    _setCondsOfSearchTarget (formData) {
      if (!Object.keys(this.conds).length) {
        return false
      }

      for (let field in this.conds) {
        // 複数選択の項目は別途セットする
        if (field === 'exchangers' || field === 'tags' || field === 'in_introducer' || field === 'out_introducer') {
          continue
        }
        formData.append(field, this.conds[field])
      }

      // 【複数選択の項目】
      // IDだけ抜き出してセットする
      // 社内紹介者
      if (this.conds.in_introducer) {
        for (let in_introducer of this.conds.in_introducer) {
          formData.append('in_introducer[]', in_introducer.id)
        }
      }
      // 社外紹介者
      if (this.conds.out_introducer) {
        for (let out_introducer of this.conds.out_introducer) {
          formData.append('out_introducer[]', out_introducer.id)
        }
      }
      // タグ
      if (this.conds.tags) {
        for (let tag of this.conds.tags) {
          formData.append('tags[]', tag.id)
        }
      }

      // 「削除されたユーザーが交換した名刺を検索する」ときは、交換者の条件を消す
      if (this.conds.ghost_exchangers !== this.app_flag.ON) {
        // 名刺交換者
        if (this.conds.exchangers) {
          for (let exchanger of this.conds.exchangers) {
            formData.append('exchangers[]', exchanger.id)
          }
        }
      }

      return true
    },
    onExportSuccess () {
      // エクスポート処理結果取得処理
      this.exportResult()
    },
    onExportError (vm, error) {
      // エラーメッセージを設定
      vm.message = error.response.data.data.message
      vm.modalExecuting = false
      vm.modalError = true
    },
    exportResult () {
      // 本番用
      const vm = this

      // 1秒置きにエクスポート処理結果取得処理を実行する
      const getResult = setInterval(function () {
        // 前回の結果取得が終わっていない場合、結果取得を行わない
        if (vm.isGodResult === false) {
          return
        }

        // 結果取得フラグをオフにする
        vm.isGodResult = false
        BcardRepository.getExportResult()
          .then(function (response) {
            // 処理結果：正常
            if (response.data.success) {
              // 「処理中」以外
              if (response.data.status !== 'active') {
                // 結果取得処理を止める
                clearInterval(getResult)
              }

              // 正常終了
              if (response.data.status === 'finish') {
                vm.modalExecuting = false
                vm.modalSuccess = true
              }
              // キャンセル
              else if (response.data.status === 'cancel') {
                vm.modalExecuting = false
                vm.modalCancel = true
              }
            }
            // 処理結果：失敗
            else {
              // 結果取得処理を止める
              clearInterval(getResult)
              // エクスポートエラーの出力
              vm.outputError(response.data.message)
            }
          })
          .catch(function (error) {
            // 結果取得処理を止める
            clearInterval(getResult)
            // エクスポートエラーの出力
            vm.outputError(error.response.data.data.message)
          })
          .finally(function () {
            // 結果取得フラグをオンにする
            vm.isGodResult = true
          })
      }, this.app_interval.getResult)

      this.$store.commit('setIntervals', getResult)

      // mock用
      // this.modalExecuting = false
      // this.modalSuccess = true
    },
    /**
     * エクスポートエラーの出力
     * @param String message エラーメッセージ
     */
    outputError (message) {
      // エラーメッセージを設定
      this.message = message

      this.modalExecuting = false
      this.modalError = true
    },
    download () {
      // 本番用
      const vm = this
      // ダウンロード中ではない場合のみ実行する
      if (this.isDownloading === false) {
        this.isDownloading = true

        // ダウンロード処理を行う
        this.getFileDL('bcard', 'getExport', 'bcard_export.csv')
          .catch(function (error) {
            vm.setErrorMessage(error)
          })
          .finally(function () {
            vm.isDownloading = false
          })
      }
    },
    cancel () {
      // 本番用
      const vm = this
      // エクスポートキャンセル処理を実行
      BcardRepository.cancelExport()
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncExport.vue